import { BlueprintDeployment } from "types/generated";
import { AccessResult } from "utils/access";

export const TEMPLATE_DEPLOYMENT_MESSAGE =
  "This stack can't be modified because it was created from a template deployment.";

type StackWithTemplateDeployment = {
  blueprintDeployment?: BlueprintDeployment | null;
};

/**
 * Checks if a stack was created from a template deployment.
 * If so, returns an AccessResult with result: false and an appropriate message.
 * Otherwise, returns undefined to indicate that the check passed.
 *
 * @param stack - Stack object that may contain blueprintDeployment
 * @returns AccessResult if stack was created from template deployment, undefined otherwise
 */
export const checkTemplateDeploymentAccess = (
  enableSelfServiceV2: boolean,
  stack?: StackWithTemplateDeployment
): AccessResult | undefined => {
  if (!enableSelfServiceV2) {
    return undefined;
  }

  if (stack?.blueprintDeployment) {
    return { result: false, message: TEMPLATE_DEPLOYMENT_MESSAGE };
  }
  return undefined;
};
